<template>
	<div class="tabsWrap small-12">
		<div class="small-12 tabs">
			<ul class="small-12 flex">
				<li v-for="(tab, index) in tabs" :class="{ 'is-active': tab.isActive }" :key="index">
					<a :href="$route.path + tab.href" class="flex" @click="selectTab(tab)" v-if="tab.icon == null">
						{{ tab.name }}
					</a>
					<a :href="$route.path + tab.href" class="flex vertical-align" @click="selectTab(tab)" v-else>
						<i class="material-icons-outlined">{{ tab.icon }}</i>
						{{ tab.name }}
					</a>
				</li>
			</ul>
		</div>
		<div class="small-12 tabs-details">
			<slot></slot>
		</div>
	</div>
</template>

<script>
	
	export default {

		/*
		** Set the component name
		*/

		name: 'Tabs',

		/*
		**  Return the data
		*/

		data: () => ({

	        tabs: [],

	    }),

	    /*
		**  Create the tabs
		*/

	    created() {
        
	        this.tabs = this.$children;
	        
	    },

	    /*
		**  Create the methods
		*/

	    methods: {

	        selectTab(selectedTab) {

	            this.tabs.forEach(tab => {

	                tab.isActive = (tab.name == selectedTab.name);

	            });

	            // Emit the click event
	            this.$emit('clicked', selectedTab.name);

	        }

    	}

	}

</script>